import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { AlertTriangle, Loader2, Trash2 } from "lucide-react";

export function PlatformReset() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const ready = text.trim() === "BORRAR";
  const run = async () => {
    if (!window.confirm("Se borrarán definitivamente todos los Maestros, Alumnos, talleres, reservas y pagos. ¿Continuar?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/platform-reset", { confirm: text.trim() });
      setResult(data); setText("");
      sessionStorage.clear();
      toast.success(`Plataforma reiniciada: ${data.total} registros borrados`);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Card className="p-6 space-y-4 mt-6 border-destructive/50" data-testid="platform-reset-card">
      <div className="flex items-center gap-2"><AlertTriangle className="w-5 h-5 text-destructive" /><h3 className="font-bold">Reiniciar datos de la plataforma</h3></div>
      <p className="text-sm text-muted-foreground">
        Borra definitivamente todos los Maestros, Alumnos, talleres, sesiones, reservas, pagos, mensajes y notificaciones.
        Se conservan: tu cuenta de administrador, valores UF, categorías, configuración y las fotos y mensajes de Comunidad y del fondo de portada. <strong>No se puede deshacer.</strong>
      </p>
      <div>
        <Label>Escribe BORRAR para confirmar</Label>
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="BORRAR" data-testid="platform-reset-input" />
      </div>
      <Button variant="destructive" onClick={run} disabled={!ready || busy} data-testid="platform-reset-btn">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Trash2 className="w-4 h-4 mr-1.5" />Reiniciar datos</>}
      </Button>
      {result && (
        <div className="text-xs rounded-lg bg-muted p-3" data-testid="platform-reset-result">
          <p className="font-semibold mb-1">Registros borrados: {result.total}</p>
          <p className="text-muted-foreground break-words">{Object.entries(result.deleted).map(([k, v]) => `${k}: ${v}`).join(" · ") || "Nada que borrar"}</p>
        </div>
      )}
    </Card>
  );
}
